import { IncomeDTO, IncomeFrequency, IncomeModel, IncomeType } from '../../api/useIncomeQuery';
import { getDefaultCustomBucketIndex } from '../../utils/getDefaultCustomBucketIndex';

export type FRA = 'FRA';

export interface UpsertIncomeDTO extends SocialSecurityFormValues {
  clientId: string;
  id: string | null;
  incomeType: IncomeType;
  useFra: boolean | null;
}

export interface SocialSecurityFormValues {
  earner: string;
  amount: number | null;
  startAge: number | FRA | null | undefined;
  currentlyReceivingBenefits: boolean;
  incomeFrequency: IncomeFrequency | null;
  useFra: boolean | null;
  orionManagementStyleId: number | null;
  customBucketIndex: number | null;
}

const defaultValues = {
  amount: null,
  currentlyReceivingBenefits: false,
  useFra: null,
  startAge: null,
  orionManagementStyleId: null,
  customBucketIndex: null,
};

export const dataToForm = (
  income: IncomeModel | null,
  data: IncomeDTO,
): SocialSecurityFormValues => {
  const { Options: options } = data;

  if (!income) {
    return {
      ...defaultValues,
      earner: options.OwnerOptions[0],
      incomeFrequency: options.IncomeFrequencyOptions[1].value,
    };
  }

  return {
    earner: income.Earner,
    amount: income.Amount,
    currentlyReceivingBenefits: income.CurrentlyReceivingBenefits,
    incomeFrequency: income.IncomeFrequency,
    useFra: income.UseFra,
    startAge: income.UseFra ? 'FRA' : income.StartAge,
    orionManagementStyleId: income.OrionManagementStyleId,
    customBucketIndex: getDefaultCustomBucketIndex({
      isAssetBucketingByManagementStyle: options.AssetBucketingByManagementStyle,
      customBucketIndex: income.CustomBucketIndex,
      orionManagementStyleId: income.OrionManagementStyleId,
      managementStylesOptions: options.ManagementStyles,
    }),
  };
};

export const receivingBenefitsOptions = [
  {
    value: true,
    label: 'Yes',
  },
  {
    value: false,
    label: 'No',
  },
];

export const MIN_RETIREMENT_YEAR = 1952;
export const MAX_RETIREMENT_YEAR = 1960;
